(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-charging-portal"] && !Shopify.designMode) return;
  try {
    
function updatePortal(root){const countInput=root.querySelector('[data-portal-count]');const count=Math.min(1000,Math.max(1,parseInt(countInput.value,10)||1));const addons=Array.from(root.querySelectorAll('[data-portal-addon]:checked')).map(input=>input.value);const monthly=count*7;const setup=count*(99+25*addons.length);const money=value=>value.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';root.querySelector('[data-portal-month]').textContent=money(monthly)+' netto';root.querySelector('[data-portal-setup]').textContent=money(setup)+' netto';root.querySelector('[data-portal-month-gross]').textContent=money(monthly*1.19)+' inkl. MwSt.';root.querySelector('[data-portal-setup-gross]').textContent=money(setup*1.19)+' inkl. MwSt.';const summary=root.querySelector('[data-portal-summary]');if(summary)summary.value='Portal Verwaltung · '+count+' Ladepunkte · Erweiterungen: '+(addons.join(', ')||'keine')+' · '+money(monthly)+' netto monatlich · Mindestlaufzeit 12 Monate (Jahreslizenz: '+money(monthly*12)+' netto im Voraus) · '+money(setup)+' netto einmalig';}
document.addEventListener('input',event=>{const root=event.target.closest('.ww-portal');if(root&&(event.target.matches('[data-portal-count]')||event.target.matches('[data-portal-addon]')))updatePortal(root);});
document.addEventListener('click',event=>{const choice=event.target.closest('[data-portal-choice]');if(!choice)return;const root=choice.closest('.ww-portal');const addon=Array.from(root.querySelectorAll('[data-portal-addon]')).find(input=>input.value===choice.dataset.portalChoice);if(addon)addon.checked=true;updatePortal(root);});
document.addEventListener('submit',event=>{const root=event.target.closest('.ww-portal');if(root)updatePortal(root);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-home-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ww-charge-calculator')) {
  customElements.define('ww-charge-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('reset', () => setTimeout(() => this.update(), 0));
      this.update();
    }
    update() {
      const valid = this.form.checkValidity();
      this.querySelector('.ww-calc__error').hidden = valid;
      this.querySelector('.ww-calc__numbers').hidden = !valid;
      if (!valid) return;
      const value = key => Number(this.form.elements.namedItem(key).value);
      const distance = value('km') / 100;
      const electricity = distance * value('kwh');
      const fuel = distance * value('litres');
      const solar = value('pv_share') / 100;
      const evCost = electricity * ((1 - solar) * value('electric_price') + solar * value('pv_price'));
      const fuelCost = fuel * value('fuel_price');
      const evCo2 = electricity * (1 - solar) * 0.344;
      const fuelCo2 = fuel * (this.form.elements.namedItem('fuel').value === 'diesel' ? 2.65 : 2.33);
      const costDiff = fuelCost - evCost;
      const co2Diff = fuelCo2 - evCo2;
      const locale = this.lang || 'de';
      const money = number => new Intl.NumberFormat(locale, {style:'currency',currency:'EUR',maximumFractionDigits:0}).format(number);
      const kg = number => new Intl.NumberFormat(locale, {maximumFractionDigits:0}).format(number) + ' kg';
      const put = (key, content) => this.querySelector('[data-' + key + ']').textContent = content;
      put('cost-diff', money(Math.abs(costDiff)));
      put('cost-label', Math.abs(costDiff) < 0.5 ? this.dataset.same : costDiff > 0 ? this.dataset.saving : this.dataset.extra);
      put('co2-diff', kg(Math.abs(co2Diff)));
      put('co2-label', Math.abs(co2Diff) < 0.5 ? this.dataset.same : co2Diff > 0 ? this.dataset.less : this.dataset.more);
      put('ev-cost', money(evCost));
      put('fuel-cost', money(fuelCost));
      put('ev-co2', kg(evCo2));
      put('fuel-co2', kg(fuelCo2));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ww-home-hero')) {
    customElements.define('ww-home-hero', class extends HTMLElement {
      connectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reducedMotion.addEventListener('change', () => this.schedule(), options);
        this.querySelector('[data-hero-pause]')?.addEventListener('click', event => {
          this.paused = !this.paused;
          event.currentTarget.setAttribute('aria-pressed', String(this.paused));
          event.currentTarget.setAttribute('aria-label', this.paused ? 'Automatischen Bildwechsel starten' : 'Automatischen Bildwechsel pausieren');
          event.currentTarget.textContent = this.paused ? '▶' : 'Ⅱ';
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(entries => { this.offscreen = !entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.querySelectorAll('[data-hero-direction]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.heroDirection)), options));
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('pointerdown', event => {
          this.start = event.pointerType === 'touch' && !event.target.closest('.ww-home-hero__products') ? { x: event.clientX, y: event.clientY } : null;
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.start) return;
          const delta = event.clientX - this.start.x;
          if (Math.abs(delta) > 60 && Math.abs(delta) > Math.abs(event.clientY - this.start.y) * 1.5) this.show(this.index + (delta < 0 ? 1 : -1));
          this.start = null;
        }, options);
        this.addEventListener('pointercancel', () => { this.start = null; }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          this.editorSelected = true;
          if (index >= 0) this.show(index);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.schedule();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.offscreen || this.editorSelected || document.hidden || this.reducedMotion.matches) return;
        this.timer = setTimeout(() => this.show(this.index + 1, true), Number(this.dataset.interval) || 6000);
      }
      show(index, automatic = false) {
        if (!this.slides.length) return;
        const previous = this.slides[this.index];
        this.index = (index + this.slides.length) % this.slides.length;
        const active = this.slides[this.index];
        active.querySelectorAll('template[data-hero-picture]').forEach(picture => {
          const fragment = picture.content.cloneNode(true);
          fragment.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          picture.replaceWith(fragment);
        });
        this.slides.forEach(slide => {
          const selected = slide === active;
          slide.classList.toggle('is-active', selected);
          slide.toggleAttribute('inert', !selected);
          slide.setAttribute('aria-hidden', String(!selected));
        });
        if (previous !== active && previous.contains(document.activeElement)) active.querySelector('[data-hero-direction="1"]')?.focus();
        const status = this.querySelector('[data-hero-status]');
        if (status) { status.setAttribute('aria-live', automatic ? 'off' : 'polite'); status.textContent = `${this.index + 1} / ${this.slides.length}`; }
        this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-installation-inquiry"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ww-install-request .ir-form').forEach(form => {
 if (form.dataset.mailReady) return;
 form.dataset.mailReady = 'true';
 const existing = form.elements.existing;
 const choice = form.querySelector('.ir-wallbox-choice');
 const model = form.querySelector('.ir-existing-model');
 const update = () => {
  const needsWallbox = existing.value === 'Nein';
  const hasWallbox = existing.value === 'Ja';
  choice.hidden = !needsWallbox;
  form.elements.wallbox.disabled = !needsWallbox;
  form.elements.wallbox.required = needsWallbox;
  model.hidden = !hasWallbox;
  form.elements.model.disabled = !hasWallbox;
 };
 existing.addEventListener('change', update);
 update();
 form.addEventListener('submit', event => {
  event.preventDefault();
  if (!form.reportValidity()) return;
  const d = new FormData(form);
  const v = name => d.get(name) || 'Keine Angabe';
  const body = [
   'Guten Tag liebes Installationsteam,','', 'ich bitte um ein kostenloses Angebot für ' + (v('existing') === 'Ja' ? 'die Installation meiner vorhandenen Wallbox.' : 'Wallbox inklusive Installation.'),'',
   'Vor- und Nachname: ' + v('name'), 'E-Mail: ' + v('email'), 'Telefon: ' + v('phone'),
   'Installationsadresse: ' + v('address'), 'Wallbox vorhanden: ' + v('existing'),
   'Wallbox: ' + (v('existing') === 'Nein' ? v('wallbox') : v('model')),
   'Montageort: ' + v('location'), 'Entfernung Zählerschrank zum Montageort: ' + v('distance'),
   'Installationszeitraum: ' + v('timing'), '', 'Zusätzliche Angaben:',
   'Wanddurchbrüche: ' + v('openings'), 'Kabel / Starkstromanschluss: ' + v('connection'),
   'PV-Anlage: ' + v('pv'), 'PV-Überschussladen: ' + v('solar'), 'Ladeleistung: ' + v('power'),
   'Anmerkungen: ' + v('details'), '', 'Fotos: Bitte vor dem Versand als Anhänge ergänzen (Zählerschrank, Kabelweg, Montageort).'
  ].join('\n');
  window.location.href = 'mailto:installation@wallboxwelt.de?subject=' + encodeURIComponent('Installationsanfrage – ' + v('name')) + '&body=' + encodeURIComponent(body);
  const status = form.querySelector('.ir-status');
  status.hidden = false;
  status.textContent = 'Bitte prüfen Sie die E-Mail, hängen Sie Ihre Fotos an und senden Sie die Anfrage in Ihrem Mailprogramm ab.';
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-powerwall-page"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const button=event.target.closest('[data-energy-video]');if(!button)return;const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+button.dataset.energyVideo+'?autoplay=1&rel=0';frame.title=button.dataset.videoTitle;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';button.parentElement.replaceChildren(frame);frame.focus();});document.addEventListener('click',function(event){const button=event.target.closest('[data-pw-image]');if(!button)return;const gallery=button.closest('.pw-gallery');const image=gallery.querySelector('[data-pw-main]');image.src=button.dataset.pwImage;image.alt='Tesla Powerwall 3P – '+button.dataset.pwAlt;gallery.querySelectorAll('[data-pw-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});
  } catch(e) { console.error(e); }
})();
})();
